import script from "./VideoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSection.vue?vue&type=script&setup=true&lang=js"

import "./VideoSection.vue?vue&type=style&index=0&id=94ad9bea&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ad9bea"]])

export default __exports__